var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#04C500",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    d: "M18.309 15.274c0 .3-.067.609-.209.909-.141.3-.325.583-.566.85-.409.45-.859.775-1.367.983-.5.208-1.042.317-1.625.317-.85 0-1.758-.2-2.717-.609a14.6 14.6 0 0 1-2.866-1.65 24 24 0 0 1-2.734-2.333A24 24 0 0 1 3.9 11.016c-.683-.95-1.233-1.9-1.633-2.842q-.6-1.425-.6-2.725c0-.566.1-1.108.3-1.608.2-.508.517-.975.958-1.392.534-.525 1.117-.783 1.734-.783.233 0 .466.05.675.15.216.1.408.25.558.467l1.933 2.725q.223.31.334.583c.075.175.116.35.116.508 0 .2-.058.4-.175.592a2.8 2.8 0 0 1-.466.592L7 7.94a.45.45 0 0 0-.133.333c0 .067.008.125.025.192.025.067.05.117.067.167q.225.415.775 1.066.56.652 1.208 1.317c.45.442.883.85 1.325 1.225.433.367.792.617 1.075.767.042.016.092.041.15.066a.6.6 0 0 0 .208.034c.142 0 .25-.05.342-.142l.633-.625a2.6 2.6 0 0 1 .6-.467 1.1 1.1 0 0 1 .592-.175q.235-.002.508.109c.184.075.375.183.584.325l2.758 1.958q.323.223.458.533c.084.209.134.417.134.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#04C500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    d: "M15.417 7.499c0-.5-.392-1.267-.975-1.892-.534-.575-1.242-1.025-1.942-1.025M18.333 7.5A5.83 5.83 0 0 0 12.5 1.665"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLight);
export default __webpack_public_path__ + "static/media/phoneLight.d76498ba8d42d1adf8e59d32158d8ab0.svg";
export { ForwardRef as ReactComponent };